export default __webpack_public_path__ + "static/photo-david-403097e544b007c839a0c16c861ee3b9.webp";